// extracted by mini-css-extract-plugin
export default {"mainChart":"Skeleton-module__mainChart--d0Ngv","title":"Skeleton-module__title--lxPLr","subtitle":"Skeleton-module__subtitle--kj_CL"};